<!--代办处补货数量-->
<template>
  <div class="AgentReplenishmentQuantity app-container">
    <app-breadcrumb/>
    <div class="page-container">
      <el-form size="small" :inline="true" :model="listQuery" label-position="right">
        <!-- 商品编号-->
        <el-form-item :label="$t('pdProductsDetail.productNo') + ':'">
          <el-input v-model.trim="listQuery.goodscode" clearable />
        </el-form-item>
        <el-button :loading="doLoading" type="primary" icon="el-icon-search" size="small" @click="handleFilter">
          {{ this.$t('operation.button.search') }}
        </el-button>
      </el-form>
      <el-table
          v-loading="doLoading"
          :data="list"
          border
          fit
          size="mini"
          stripe
          style="width: 100%"
          height="600"
      >
        <!-- 商品名称 -->
        <el-table-column :label="$t('BiGoods.name')" prop="name" align="center"/>
        <!-- 商品编码 -->
        <el-table-column :label="$t('BiGoods.goodsCode')" prop="goodscode" align="center"/>
        <!--     商品编码(旧) -->
        <el-table-column :label="$t('Old_goodsCode')" prop="oldcode" align="center" />
        <!-- 欠货数量 -->
        <el-table-column :label="$t('pd.goodsNum.owe')" prop="oweqty" align="center"/>
      </el-table>
      <pagination
          v-show="total>0"
          :total="total"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.limit"
          @pagination="getList"
      />
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination"
import {agentWareStocks} from "@/api/agent"

export default {
  name: 'AgentReplenishmentQuantity',
  directives: {},
  components: {Pagination},
  data() {
    return {
      doLoading: false,
      list: [],
      total: 0,
      listQuery: {
        goodscode: '',
        page: 1,
        limit: 10
      }
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    getList() {
      this.doLoading = true
      agentWareStocks({ ...this.listQuery }).then(res => {
        let newList = []
        res.data.records.forEach(v=>{
          if(v.goodscode !== 'BD-N000003-24' && v.goodscode !== 'BD-N000008-24' && v.goodscode !== 'BD-N000009-24'
            && v.goodscode !== 'BD-N000012-24' && v.goodscode !== 'BD-N000013-24' && v.goodscode !== 'BD-N000014-24'
          ){
            newList.push(v)
          }
        })
        this.list = newList
        this.total = +res.data.total || 0
        this.doLoading = false
      }).catch(err => {
        console.warn(err)
        this.doLoading = false
      })
    }
  }
}

</script>

<style scoped>

</style>
